<template>
  <div id="app" class="scrolled flex flex-col min-h-screen transition-colors duration-500 ease-in-out justify-between">

    <!-- PARTICLE BACKGROUND -->
    <particles-bg type="lines" :bg="true" :canvas="canvasObject" />

    <!-- NAVBAR -->
    <transition name="fadeDown">
      <Navbar v-show="mounted.navbar" 
      :selected="navbarItem"
      class="z-40" />
    </transition>
    <!-- /NAVBAR -->

    <!-- /CONTENT -->
    <div class="
      py-4 px-0
      lg:pt-32 
      md:py-12 md:px-8
      container mx-auto text-center z-20">
      <transition name="fade" mode="out-in">
      <router-view></router-view>
      </transition>
    </div>
    <!-- CONTENT -->

    <!-- FOOTER -->
    <Footer />
    <!-- /FOOTER -->

    <transition name="fade">
    <Loader v-if="loader" />
    </transition>

    <!-- TOASTER -->
    <transition name="fadeRight" >
      <toaster v-if="toaster.show"
      :type="toaster.type"
      :message="toaster.message"
      :time="toaster.time"
      :show="toaster.show"
      @close-toaster="$store.commit('closeToaster')" />
    </transition>

  </div>
</template>

<script>
import { ParticlesBg } from "particles-bg-vue";

import Loader  from '@/components/loader.vue'
import Navbar  from '@/components/navbar.vue'
import Footer  from '@/components/footer.vue'
import Toaster from '@/components/toaster.vue'
export default {
  name: "App",
  components: {
    Loader, Navbar, 
    Footer, Toaster,
    ParticlesBg
  },
  watch: {
    darkMode: (newval) => {
      newval ? document.documentElement.classList.add('dark'):document.documentElement.classList.remove('dark')
    }
  },
  data:()=>({
    loader: true,
    mounted:{
      navbar:false,
    },
    ProjectsItems: [],
    canvasObject: {
      position: 'fixed',
    },
  }),
  async mounted() {
    const delay = ms => new Promise(res => setTimeout(res, ms));
    await delay(150)
    this.loader = false
    await delay(350)
    this.mounted.navbar = true
  },
  computed: {
    navbarItem() {
      return this.$route.name
    },
    darkMode() {
      return this.$store.getters.GetDarkMode
    },
    toaster() {
      return this.$store.getters.GetToaster
    }
  }
};
</script>
